import { Button, buttonClass } from "../../components/ui/Button";
import { api } from "../../lib/api/endpoints";
import { BrandFrame } from "./BrandFrame";

export function NoAccessPage() {
  const signOut = async () => {
    await api.logout().catch(() => {});
    window.location.assign("/signin");
  };
  return (
    <BrandFrame>
      <h1 className="text-2xl font-semibold text-ink">You don't have access to Klarity Docs</h1>
      <p className="mt-3 text-ink-2">
        Your account is signed in but is not in one of the Klarity Docs groups, or this page needs a role you don't
        have. Ask an admin to add you to KD-Viewers, KD-Editors or KD-Admins, then sign in again.
      </p>
      <div className="mt-6 flex flex-wrap gap-2">
        <Button variant="primary" className="h-11 md:h-9" onClick={() => void signOut()}>
          Sign in with another account
        </Button>
        <a href="/" className={buttonClass({}, "h-11 md:h-9")}>
          Go to the start page
        </a>
      </div>
    </BrandFrame>
  );
}
